__turbopack_context__.v({
  "container": "FullBodyUpload-module-scss-module__Aoe1MW__container",
  "imageContainer": "FullBodyUpload-module-scss-module__Aoe1MW__imageContainer",
});
